export const authorizationErrors = {
	exceededMaxTrys: {
		absolutePath: '/authorization/exceededMaxTrys',
	},
	guExceededMaxTrys: {
		absolutePath: '/authorization/guExceededMaxTrys',
	},
	blockedUser: {
		absolutePath: '/authorization/blockedUser',
	},
	unexpectedError: {
		absolutePath: '/authorization/unexpectedError',
	},
	minorCitizenUser: {
		absolutePath: '/authorization/minorCitizenUser',
	},
	userNotCitizenRF: {
		absolutePath: '/authorization/userNotCitizenRF',
	},
	timeExpiredForConfirm: {
		absolutePath: '/authorization/timeExpiredForConfirm',
	},
	phoneIsUsed: {
		absolutePath: '/authorization/phoneIsUsed',
	},
};
export const authorizationRoutes = {
	authorization: {
		absolutePath: '/authorization',
		loginByPhone: {
			absolutePath: '/authorization/loginByPhone',
		},
		registrationByPhone: {
			absolutePath: '/authorization/registrationByPhone',
		},
		registrationByGU: {
			absolutePath: '/authorization/registrationByGU',
		},
		...authorizationErrors,
	},
};
